import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useAuth0 } from '@/utils/auth/auth0'
import { clearDatabaseSearchStorage } from '@/utils/databaseSearchSession'

export default function LoginConflictMessage() {
  const { logout } = useAuth0()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        minHeight: isMobile ? '100dvh' : '100vh',
        px: isMobile ? 2 : 3,
        py: isMobile ? 4 : 0,
        mb: isMobile ? 15 : 0,
        boxSizing: 'border-box',
      }}
    >
      <img
        src={`/Fundsorter-h-black800px.png`}
        alt="Fundsorter Logo"
        style={{
          width: isMobile ? '180px' : '250px',
          height: 'auto',
          marginBottom: isMobile ? '24px' : '32px',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          backgroundColor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 3,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          p: isMobile ? 2.5 : 4,
          textAlign: 'center',
          width: '100%',
          maxWidth: '500px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            backgroundColor: '#fff3cd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
          }}
        >
          <Typography sx={{ fontSize: '24px' }}>⚠️</Typography>
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontSize: isMobile ? '20px' : '24px',
            fontWeight: 600,
            color: '#1C3045',
            mb: 1,
          }}
        >
          Try signing in a different way
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '16px',
            color: '#4a5568',
            lineHeight: 1.6,
            mb: 1,
          }}
        >
          Looks like you signed in a different way than when you first
          registered. Nothing's wrong with your login — you just need to use the
          same method you started with.
        </Typography>

        <Box
          sx={{
            width: '100%',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
            textAlign: 'left',
            my: 1,
          }}
        >
          <Box sx={{ p: 2 }}>
            <Typography sx={{ fontSize: '15px', color: '#4a5568', mb: 0.5 }}>
              If you first signed up with Google
            </Typography>
            <Typography
              sx={{ fontSize: '17px', fontWeight: 700, color: '#1C3045' }}
            >
              → Sign in with Google
            </Typography>
          </Box>
          <Box sx={{ borderTop: '1px solid #e0e0e0', p: 2 }}>
            <Typography sx={{ fontSize: '15px', color: '#4a5568', mb: 0.5 }}>
              If you first signed up with an email and password
            </Typography>
            <Typography
              sx={{ fontSize: '17px', fontWeight: 700, color: '#1C3045' }}
            >
              → Sign in with your email and password
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontSize: '14px',
            color: '#718096',
            lineHeight: 1.5,
          }}
        >
          Once you're signed in, you can set up both methods <br />
          so either one works next time. <br />
          Find this under Manage Organisation → Login & Security.
        </Typography>

        <Button
          variant="contained"
          disableRipple
          sx={{
            mt: 3,
            backgroundColor: '#1C3045',
            '&:hover': {
              backgroundColor: '#2d4a5f',
            },
            borderRadius: 1,
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontSize: '16px',
            maxHeight: '40px',
          }}
          onClick={() => {
            clearDatabaseSearchStorage()
            logout({ returnTo: window.location.origin })
          }}
        >
          Back to Login
        </Button>
      </Box>
    </Box>
  )
}
